import {createMuiTheme} from "@material-ui/core";

export const ERROR_COLOR = '#E50000';
export const ERROR_BACKGROUND = '#FCE0E0';
export const SUCCESS_COLOR = '#23D374';
export const SUCCESS_BACKGROUND = '#E5FAEE';
export const INFO_COLOR = '#0092E5';
export const INFO_BACKGROUND = '#E4F2FC';
export const WARNING_COLOR = '#FF9D00';
export const WARNING_BACKGROUND = '#FFF3E0';
export const GREY_INFO_COLOR = '#838A93';

export const DEFAULT_THEME_COLOR = INFO_COLOR;


export function createDefaultTheme(extensions={}, color=DEFAULT_THEME_COLOR) {
  const theme = getThemeConfig(color);
  return createMuiTheme({...theme, ...extensions});
}

function getThemeConfig(color) {
  return {
    typography: {
      useNextVariants: true,
    },
    palette: {
      primary: {
        main: color,
        contrastText: '#fff'
      },
      secondary: {
        main: ERROR_COLOR
      }
    },
    overrides: {
      MuiCheckbox: {
        root: {
          '& svg': {
            //fill: '#B1B1B1 !important',
          }
        },
      },
      MuiCard: {
        root: {
          overflow: 'visible'
        }
      },
      MuiExpansionPanel: {
        root: {
          zIndex: 100
        }
      },
      MuiMenu: {
        paper: {
          boxShadow: 'none',
          border: `2px solid ${color}`,
        },
        list: {
          padding: 0
        }
      },
      MuiListItem: {
        root: {
          transition: 'all',
          transitionDuration: '0.2s',
          padding: '10',
          fontFamily: 'Roboto-Bold !important',
          color: color,
          fontSize: 14,

          '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#EFEFF2'
          }
        }
      },
      MuiDialog: {
        paper: {
          boxShadow: 'none',
          borderRadius: 2
        }
      },
      MuiAccordion: {
        root: {
          margin: 0,
          '&$expanded': {
            margin: 0,
          },
          '&:before': {
            display: 'none',
          },
        },
      }
    }
    // Here you can set or override all your variables and settings related to styling.
    // https://material-ui.com/customization/themes/
  };
}